import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import logo from '../assets/logo.png';
import gokuhome from '../assets/gokuhome.jpg';
import gokuhomemobile from '../assets/gokuhomemobile.jpg';

// Landing Container
const LandingContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background-image: url(${gokuhome});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 1;
  }
  
  @media (max-width: 768px) {
    background-image: url(${gokuhomemobile});
    padding: 1rem;
  }
`;

// Content Container
const ContentContainer = styled.div`
  position: relative;
  z-index: 2;
  text-align: center;
  max-width: 800px;
  animation: fadeIn 1s ease;
  
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(20px); }
    to { opacity: 1; transform: translateY(0); }
  }
`;

// Logo Container
const LogoContainer = styled.div`
  margin-bottom: 3rem;
`;

// Logo Image
const LogoImage = styled.img`
  width: 120px;
  height: 120px;
  object-fit: contain;
`;

// Site Title
const SiteTitle = styled.h1`
  font-size: 3rem;
  font-weight: 700;
  color: white;
  margin: 0 0 0.5rem;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
  
  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

// Subtitle
const Subtitle = styled.p`
  font-size: 1.2rem;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 3rem;
  
  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

// Buttons Container
const ButtonsContainer = styled.div`
  display: flex;
  gap: 1.5rem;
  margin-top: 2rem;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
  }
`;

// Button
const Button = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 1rem 2.5rem;
  border-radius: 8px;
  font-weight: 600;
  font-size: 1.1rem;
  text-decoration: none;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 7px 14px rgba(0, 0, 0, 0.2);
  }
  
  @media (max-width: 768px) {
    width: 100%;
    padding: 0.8rem 2rem;
  }
`;

// Primary Button
const PrimaryButton = styled(Button)`
  background: var(--primary-color);
  color: white;
  
  &:hover {
    background: var(--primary-light);
  }
`;

// Secondary Button
const SecondaryButton = styled(Button)`
  background: transparent;
  color: white;
  border: 2px solid white;
  
  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
`;

const LandingPage = () => {
  return (
    <LandingContainer>
      <ContentContainer>
        <LogoContainer>
          <LogoImage src={logo} alt="Logo" />
        </LogoContainer>
        
        <Subtitle>
          Anime in Hindi, For Free
        </Subtitle>
        
        <ButtonsContainer>
          <PrimaryButton to="/login">Sign In</PrimaryButton>
          <SecondaryButton to="/register">Create Account</SecondaryButton>
        </ButtonsContainer>
      </ContentContainer>
    </LandingContainer>
  );
};

export default LandingPage; 